export default "__VITE_ASSET__CORLsxro__"